export enum RecurringTaskModalModes {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
